import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "./../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "./../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addsetmaster.html",
})
export class addsetmaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  headList =["F/S", "H/S"];
  nameList = ["1","2" ,"3","4","5","6","7","8"];

  codeList: any;
  seasonList: any;

  execApi: boolean = true;
  //  isEdit: boolean = false;
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];

  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  varietyList = ["CHECKS","PLAIN"];
  widthList = ["36", "44", "58"];
  styleList = ["FORMAL", "CASUAL"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  qualitylist: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    // this.sale_type = val["sale_type"];
    // this.upd_type = val["upd_type"];
    // // this.saveEvent = val["data"].tabevent;
    // this.qualitylist = [];
    // let invoicedata = Object.assign({}, val["data"]);
    // this.invoicedata = invoicedata;
    // this.invoicedata.mode = 'Add'
    // console.log(this.mode, this.upd_type);
    // if (this.mode == "Convert") {
    //   this.invoicedata.mode = "Add";
    // }

    // if (this.mode == "Convert") {
    //    this.editInvoiceList();
    //   this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    //   //   this.oncheck(this.invoicedata.salesorder);
    // }
    // if (this.mode == "View" || this.mode == "Edit") {

    //   console.log(this.invoicedata, this.upd_type);
    //   //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    // }

    this.getSetDetails();
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService

  ) {
    this.row = {
      width: "",
      size: "",
      sleeve: "",
      type: "",
      
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.invoicedata.mode = this.mode;

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  OnselectpartyId(type){
   let temp = this.partyList.filter(el=>el.code == type);
   this.invoicedata.party_id = temp[0].party_id;


  }
  buttonStyle() {
    const style = {
     Position : "relative",
      left: this.mode == "Add" ? "90%" : "85%",
      bottom: "54px"
    };
    return style;
  }

  addPlainDetails() {
    console.log(this.qualitylist);
    

    if (!/^\d+-\d+$/.test(this.invoicedata.set_combo)) {
      swal("ERROR", "Not Valid Format  <h1>Use X-Y</h1>", "error");
      return
    } 
    if(!this.invoicedata.sleeve||!this.invoicedata.priority||!this.invoicedata.set_combo){
      swal("ERROR", "Empty Data Not Allowed!!", "error");
      return
    }
   
    if(this.data.invoiceList.find(x=>x.sleeve.trim() == this.invoicedata.sleeve && x.set_combo.trim() == this.invoicedata.set_combo&& x.priority.trim() == this.invoicedata.priority && !x.isdeleted ))
    
    {
      swal("ERROR", "SAME COMBINATION ALREADY EXIST", "error");
      return;
    }
    if(this.data.invoiceList.find(x=>x.sleeve.trim() == this.invoicedata.sleeve && x.set_combo.trim() == this.invoicedata.set_combo && !x.isdeleted ))
    
      {
        swal("ERROR", "SET COMBINATION ALREADY EXIST", "error");
        return;
      }
    
    if(this.data.invoiceList.find(x=>x.sleeve.trim() == this.invoicedata.sleeve && x.priority.trim() == this.invoicedata.priority && !x.isdeleted ))
    
        {
          swal("ERROR", "PRIORITY ALREADY EXIST IN SLEEVE", "error");
          return;
        }
    
    //need addition restriction for priority allowed once (h/s = 1 (pri) or f/s = 1 (pri))

    console.log(this.invoicedata)
    delete this.invoicedata.tabevent;



     //For Groupwise Pushing
    let insertIndex = -1; // Default to -1 (append at the end if no match)
    
    // Find the last index where sleeve matches
    this.data.invoiceList.forEach((item, index) => {
        if (item.sleeve === this.invoicedata.sleeve) {
            insertIndex = index + 1; // Update insert position to be after the last match
        }
    });

    // Insert invData at the found position
    if (insertIndex !== -1) {
      this.data.invoiceList.splice(insertIndex, 0, this.invoicedata);
    } else {
        this.data.invoiceList.push(this.invoicedata); // If no match found, append at the end
    }



   // this.data.invoiceList.push(this.invoicedata);


    console.log(this.data.invoiceList, "after pushhhh ");
    var bottom = document.querySelector("#salesTbody");
    setTimeout(() => {
      bottom.scrollTop = bottom.scrollHeight;
    }, 400);

    this.invoicedata = new Object();

  }
  onEnterKeyPressed(nextEl: string) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }

  }

 
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  getEditMode(ind) {
      
    this.data.invoiceList[ind].isEdit = !this.data.invoiceList[ind].isEdit;
    console.log(this.data.invoiceList, "check Listsssssssssss")
  }

  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {

          that.data.invoiceList[ind].isdeleted = true
          console.log(that.data.invoiceList, "check deleteeee")
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }
  getSetDetails() {
 
    this.salesinvservice.getSetDetails({}).then((res: any) => {
      this.data.invoiceList = res.data;
      console.log(this.data.invoiceList, "check after listtttt")
      var bottom = document.querySelector("#salesTbody");
      bottom.scrollTop = bottom.scrollHeight;
    });
  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  // getAutoNumber() {

  //   this.salesinvservice.getMultiFabAuto({}).then((res: any) => {
  //     this.invoicedata.ref_no = res;
  //   });
  // }


  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  oncheckemptyrow(){
  
    console.log("check set data...........",this.data.invoiceList)
    const seenPriorityCombinations = {}; // Track sleeve + priority
    const seenSetCombinations = {}; // Track sleeve + set_combo
    let duplicateFound = false;
    
    this.data.invoiceList.forEach(item => {
        if (item.isdeleted) return; // Skip items marked as deleted
    
        const priorityKey = `${item.sleeve}-${item.priority}`;
        const setComboKey = `${item.sleeve}-${item.set_combo}`;
    
        if (seenPriorityCombinations[priorityKey]) {
          swal(`ERROR`, `SLEEVE - ${item.sleeve}, PRIORITY - ${item.priority} ALREADY EXISTS`, `error` );
            duplicateFound = true;
        } else {
            seenPriorityCombinations[priorityKey] = true;
        }
    
        if (seenSetCombinations[setComboKey]) {
          swal(`ERROR`, `SLEEVE - ${item.sleeve}, SET COMBO - ${item.set_combo} ALREADY EXISTS`, `error` );
            duplicateFound = true;
        } else {
            seenSetCombinations[setComboKey] = true;
        }
    });

    //Not Execute the save Part!!
    if(duplicateFound) return
    


     
    
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    let that = this;

    swal({
      title: "Are you sure to save this Changes?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .savesetDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal("This Design" +" " + res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
 
}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/addsetmaster.ts